// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes MobileTabletCallback_appear__HmVMr {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes MobileTabletCallback_appearTablet__4-jIv {
    from {
        opacity: 0;
        transform: translateY(20px) translateX(-50%);
    }
    to {
        opacity: 1;
        transform: translateY(0) translateX(-50%);
    }
}

.MobileTabletCallback_container__RlpsI {
    position: fixed;
    background-color: #111018;
    color: #fff;
    padding: 32px 32px;
    z-index: 3000;
    animation: MobileTabletCallback_appear__HmVMr 0.5s ease-out;
    overflow-y: auto;
}

.MobileTabletCallback_header__PWB9s {
    margin-top: 8%;
    display: flex;
    align-items: center;
}

.MobileTabletCallback_closeButton__MgHqA {
    position: absolute;
    top: 1%;
    right: 3%;
    border: none;
    background-color: #ffffff20;
    border-radius: 50%;
    aspect-ratio: 1;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MobileTabletCallback_title__ducy9 {
    font-size: var(--font-size-11);
    font-family: var(--font-semi-bold), sans-serif;
}

.MobileTabletCallback_description__7rdw4 {
    font-size: var(--font-size-6);
    line-height: 24px;
    font-family: var(--font-medium), sans-serif;
}

.MobileTabletCallback_bottomText__qjsV- {
    font-family: var(--font-medium), sans-serif;
    text-align: center;
    line-height: 24px;
    font-size: var(--font-size-6);
    margin-top: 6%;
}

.MobileTabletCallback_helpWrapper__PV2rN {
    font-family: var(--font-medium), sans-serif;
    font-size: var(--font-size-6);
    display: inline-block;
    text-align: center;
}

.MobileTabletCallback_help__R6ONQ {
    display: inline-block;
    cursor: pointer;
    text-decoration-line: underline;
}

@media (max-width: 767px) {
    .MobileTabletCallback_container__RlpsI {
        right: 0;
        left: 0;
        bottom: 0;
        top: 0;
        max-width: 100%;
        padding: 16px 32px;
        border-radius: 0px;
    }

    .MobileTabletCallback_header__PWB9s {
        margin-top: 6%;
    }

    .MobileTabletCallback_closeButton__MgHqA {
        top: 2.5%;
        right: 9%;
    }

    .MobileTabletCallback_description__7rdw4 {
        line-height: 20px;
        margin-top: 8px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .MobileTabletCallback_container__RlpsI {
        bottom: 9%;
        left: 50%;
        transform: translateX(-50%);
        width: 95%;
        max-width: none;
        border-radius: 16px;
        top: unset;
        animation: MobileTabletCallback_appearTablet__4-jIv 0.5s ease-out;
    }

    .MobileTabletCallback_header__PWB9s {
        margin-top: 0%;
    }
}

@media (min-width: 1024px) {
    .MobileTabletCallback_container__RlpsI {
        height: -moz-fit-content;
        height: fit-content;
        bottom: 9%;
        left: 50%;
        transform: translateX(-50%);
        width: 68%;
        border-radius: 16px;
        top: unset;
        animation: MobileTabletCallback_appearTablet__4-jIv 0.5s ease-out;
    }

    .MobileTabletCallback_header__PWB9s {
        margin-top: 0%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/MobileTabletCallback/MobileTabletCallback.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,4CAA4C;IAChD;IACA;QACI,UAAU;QACV,yCAAyC;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,2DAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI;QACI,QAAQ;QACR,OAAO;QACP,SAAS;QACT,MAAM;QACN,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,eAAe;QACf,mBAAmB;QACnB,UAAU;QACV,iEAAqC;IACzC;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,wBAAmB;QAAnB,mBAAmB;QACnB,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,mBAAmB;QACnB,UAAU;QACV,iEAAqC;IACzC;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["@keyframes appear {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes appearTablet {\n    from {\n        opacity: 0;\n        transform: translateY(20px) translateX(-50%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) translateX(-50%);\n    }\n}\n\n.container {\n    position: fixed;\n    background-color: #111018;\n    color: #fff;\n    padding: 32px 32px;\n    z-index: 3000;\n    animation: appear 0.5s ease-out;\n    overflow-y: auto;\n}\n\n.header {\n    margin-top: 8%;\n    display: flex;\n    align-items: center;\n}\n\n.closeButton {\n    position: absolute;\n    top: 1%;\n    right: 3%;\n    border: none;\n    background-color: #ffffff20;\n    border-radius: 50%;\n    aspect-ratio: 1;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.title {\n    font-size: var(--font-size-11);\n    font-family: var(--font-semi-bold), sans-serif;\n}\n\n.description {\n    font-size: var(--font-size-6);\n    line-height: 24px;\n    font-family: var(--font-medium), sans-serif;\n}\n\n.bottomText {\n    font-family: var(--font-medium), sans-serif;\n    text-align: center;\n    line-height: 24px;\n    font-size: var(--font-size-6);\n    margin-top: 6%;\n}\n\n.helpWrapper {\n    font-family: var(--font-medium), sans-serif;\n    font-size: var(--font-size-6);\n    display: inline-block;\n    text-align: center;\n}\n\n.help {\n    display: inline-block;\n    cursor: pointer;\n    text-decoration-line: underline;\n}\n\n@media (max-width: 767px) {\n    .container {\n        right: 0;\n        left: 0;\n        bottom: 0;\n        top: 0;\n        max-width: 100%;\n        padding: 16px 32px;\n        border-radius: 0px;\n    }\n\n    .header {\n        margin-top: 6%;\n    }\n\n    .closeButton {\n        top: 2.5%;\n        right: 9%;\n    }\n\n    .description {\n        line-height: 20px;\n        margin-top: 8px;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .container {\n        bottom: 9%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 95%;\n        max-width: none;\n        border-radius: 16px;\n        top: unset;\n        animation: appearTablet 0.5s ease-out;\n    }\n\n    .header {\n        margin-top: 0%;\n    }\n}\n\n@media (min-width: 1024px) {\n    .container {\n        height: fit-content;\n        bottom: 9%;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 68%;\n        border-radius: 16px;\n        top: unset;\n        animation: appearTablet 0.5s ease-out;\n    }\n\n    .header {\n        margin-top: 0%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileTabletCallback_container__RlpsI`,
	"appear": `MobileTabletCallback_appear__HmVMr`,
	"header": `MobileTabletCallback_header__PWB9s`,
	"closeButton": `MobileTabletCallback_closeButton__MgHqA`,
	"title": `MobileTabletCallback_title__ducy9`,
	"description": `MobileTabletCallback_description__7rdw4`,
	"bottomText": `MobileTabletCallback_bottomText__qjsV-`,
	"helpWrapper": `MobileTabletCallback_helpWrapper__PV2rN`,
	"help": `MobileTabletCallback_help__R6ONQ`,
	"appearTablet": `MobileTabletCallback_appearTablet__4-jIv`
};
export default ___CSS_LOADER_EXPORT___;
